<template>
  <div
    :class="['campaign-form-container', { 'mt-0 pt-0 pb-2': props.source && props.source.includes('update'), 'py-2': !props.source }]">
    <h3 class="form-title" v-if="!props.source">Campaign Details</h3>
    <b-form class="mt-4">
      <b-form-group label-class="punch-card-form-label">
        <template slot="label">
          Campaign Name <span class="text-muted">(This will serve as the Stamp Label reflected on the card)</span>
        </template>
        <b-form-input id="input-punch-card-campaign-name" v-model="campaignData.details.name"
          placeholder="Campaign Name" :maxlength="maxLengths.name" :state="!$v.name.$errors.length || !!apiErrors.name"
          :class="{ 'border-danger': $v.name.$errors.length || !!apiErrors.name }"></b-form-input>
        <b-form-invalid-feedback :force-show="$v.name.$errors.length > 0 || !!apiErrors.name">
          <template v-if="!!apiErrors.name">{{ apiErrors.name }}</template>
          <p v-else class="mb-0" v-for="error in $v.name.$errors" :key="error.$uid">{{ error.$message }}</p>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-class="punch-card-form-label" label="Description">
        <b-textarea id="textarea-punch-card-campaign-description" v-model="campaignData.details.description" rows="5"
          :maxlength="maxLengths.description" placeholder="Lorem ipsum dolor sit amet consectetur. Quis elementum nisl"
          :state="!$v.description.$errors.length || !!apiErrors.description"
          :class="{ 'border-danger': $v.description.$errors.length || !!apiErrors.description }"></b-textarea>
        <b-form-invalid-feedback :force-show="$v.description.$errors.length > 0 || !!apiErrors.description">
          <template v-if="!!apiErrors.description">{{ apiErrors.description }}</template>
          <p v-else class="mb-0" v-for="error in $v.description.$errors" :key="error.$uid">{{ error.$message }}</p>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-class="punch-card-form-label" label="Terms and Conditions">
        <b-textarea id="textarea-punch-card-campaign-terms-condition" v-model="campaignData.details.terms_condition"
          rows="5" :maxlength="maxLengths.terms_condition"
          placeholder="Lorem ipsum dolor sit amet consectetur. Quis elementum nisl"
          :state="!$v.terms_condition.$errors.length || !!apiErrors.terms_condition"
          :class="{ 'border-danger': $v.terms_condition.$errors.length || !!apiErrors.terms_condition }"></b-textarea>
        <b-form-invalid-feedback :force-show="$v.terms_condition.$errors.length > 0 || !!apiErrors.terms_condition">
          <template v-if="!!apiErrors.terms_condition">{{ apiErrors.terms_condition }}</template>
          <p v-else class="mb-0" v-for="error in $v.terms_condition.$errors" :key="error.$uid">{{ error.$message }}</p>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-class="punch-card-form-label" label="Website URL">
        <b-form-input id="input-punch-card-campaign-website-url" v-model="campaignData.details.website_url"
          placeholder="http://website.com" :maxlength="maxLengths.website_url"
          :state="!$v.website_url.$errors.length || !!apiErrors.website_url"
          :class="{ 'border-danger': $v.website_url.$errors.length || !!apiErrors.website_url }"></b-form-input>
        <b-form-invalid-feedback :force-show="$v.website_url.$errors.length > 0 || !!apiErrors.website_url">
          <template v-if="!!apiErrors.website_url">{{ apiErrors.website_url }}</template>
          <p v-else class="mb-0" v-for="error in $v.website_url.$errors" :key="error.$uid">{{ error.$message }}</p>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { computed, defineComponent, getCurrentInstance, onMounted, onBeforeUnmount } from "@vue/composition-api";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, helpers, url } from "@vuelidate/validators";
import { fieldRequiredErrorMessage } from "../punch.card.utilities";

export default defineComponent({
  props: ["source"],
  computed: {
    ...mapFields("punchCard", ["campaignData"]),
    ...mapGetters("punchCard", ["errors", "loading"])
  },
  setup(props, { root }) {
    const currentInstance = getCurrentInstance();

    const maxLengths = {
      name: 100,
      description: 500,
      terms_condition: 1000,
      website_url: 100
    };

    const form = computed(() => ({ ...currentInstance.proxy.campaignData.details } || {}));

    const rules = {
      name: {
        required: helpers.withMessage(fieldRequiredErrorMessage, required)
      },
      description: {
        required: helpers.withMessage(fieldRequiredErrorMessage, required)
      },
      terms_condition: {
        required: helpers.withMessage(fieldRequiredErrorMessage, required)
      },
      website_url: {
        url: helpers.withMessage("Please enter a valid URL.", url)
      }
    };

    const $v = useVuelidate(rules, form);

    onMounted(() => {
      root.$on("validateForm", async () => {
        $v.value.$touch();

        if ($v.value.$dirty && !$v.value.$invalid && !currentInstance.proxy.loading) {
          await root.$store.dispatch("punchCard/validateCampaignName", { name: currentInstance.proxy.campaignData.details.name.trim() });

          if (!currentInstance.proxy.errors)
            root.$emit("proceedToNextStep", currentInstance.proxy.$route.name === "PunchCardCreate" ? "create" : props.source);
        }
      });
    });

    onBeforeUnmount(() => {
      root.$off("validateForm");
    });

    const apiErrors = computed(() => root.$store.state.punchCard.errors || {});

    return {
      maxLengths,
      form,
      $v,
      props,
      apiErrors
    }
  }
});
</script>
